/**
 * 天气预报组件
 * 基于高德地图API获取天气信息，支持7天预报
 */
<template>
  <div class="weather-card-wrapper">
    <!-- 有天气数据时显示 -->
    <el-popover
      v-if="weather.city"
      placement="bottom"
      width="520"
      trigger="hover"
      popper-class="weather-forecast-popover">
      <div class="forecast-content" v-if="forecast.length">
        <div class="forecast-header">
          <i class="el-icon-cloudy"></i>
          <span>{{ weather.city }} · 未来天气预报</span>
        </div>
        <div class="forecast-list">
          <div class="forecast-item" v-for="(item, index) in forecast" :key="index">
            <div class="forecast-date">
              <span class="day">{{ formatDate(item.date) }}</span>
              <span class="week">{{ formatWeek(item.week) }}</span>
            </div>
            <div class="forecast-weather">
              <i :class="getWeatherIcon(item.dayWeather)"></i>
              <span>{{ item.dayWeather }}</span>
            </div>
            <div class="forecast-temp">
              <span class="temp-low">{{ item.nightTemp }}°</span>
              <span class="temp-range"></span>
              <span class="temp-high">{{ item.dayTemp }}°</span>
            </div>
            <div class="forecast-wind">
              <span>{{ item.dayWindDir }}风 {{ item.dayWindPower }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="forecast-empty" v-else>
        <i class="el-icon-loading"></i>
        <span>加载预报中...</span>
      </div>
      <div class="weather-card" slot="reference" :class="weatherClass">
        <div class="weather-icon">
          <i :class="weatherIcon"></i>
        </div>
        <div class="weather-content">
          <span class="weather-city">{{ weather.city }}</span>
          <span class="weather-text">{{ weather.weather }}</span>
          <span class="weather-temp">{{ weather.temperature }}℃</span>
        </div>
        <div class="weather-arrow">
          <i class="el-icon-arrow-down"></i>
        </div>
      </div>
    </el-popover>
    <!-- 加载中状态 -->
    <div class="weather-card weather-loading" v-if="loading && !weather.city">
      <i class="el-icon-loading"></i>
      <span>加载中...</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WeatherCard',
  data() {
    return {
      loading: true,
      weather: {
        city: '',
        weather: '',
        temperature: '',
        winddirection: '',
        windpower: ''
      },
      forecast: []
    };
  },
  computed: {
    weatherIcon() {
      return this.getWeatherIcon(this.weather.weather);
    },
    weatherClass() {
      const weather = this.weather.weather || '';
      if (weather.includes('晴')) return 'sunny';
      if (weather.includes('云') || weather.includes('阴')) return 'cloudy';
      if (weather.includes('雨')) return 'rainy';
      if (weather.includes('雪')) return 'snowy';
      return 'sunny';
    }
  },
  mounted() {
    this.loadWeather();
  },
  methods: {
    getWeatherIcon(weather) {
      if (!weather) return 'el-icon-sunny';
      if (weather.includes('晴')) return 'el-icon-sunny';
      if (weather.includes('云') || weather.includes('阴')) return 'el-icon-cloudy';
      if (weather.includes('雨')) return 'el-icon-heavy-rain';
      if (weather.includes('雪')) return 'el-icon-ice-cream-round';
      if (weather.includes('雾') || weather.includes('霾')) return 'el-icon-cloudy';
      return 'el-icon-sunny';
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      const parts = dateStr.split('-');
      return `${parts[0]}/${parts[1]}/${parts[2]}`;
    },
    formatWeek(week) {
      const weekMap = { '1': '周一', '2': '周二', '3': '周三', '4': '周四', '5': '周五', '6': '周六', '7': '周日' };
      return weekMap[week] || '';
    },
    async loadWeather() {
      this.loading = true;
      try {
        if (typeof AMap !== 'undefined') {
          AMap.plugin('AMap.CitySearch', () => {
            const citySearch = new AMap.CitySearch();
            citySearch.getLocalCity((status, result) => {
              if (status === 'complete' && result.info === 'OK') {
                this.getWeatherByAdcode(result.adcode);
              } else {
                this.loading = false;
              }
            });
          });
        } else {
          this.loading = false;
        }
      } catch (e) {
        console.error('加载天气失败', e);
        this.loading = false;
      }
    },
    getWeatherByAdcode(adcode) {
      try {
        if (typeof AMap !== 'undefined') {
          AMap.plugin('AMap.Weather', () => {
            const weather = new AMap.Weather();
            // 获取实时天气
            weather.getLive(adcode, (err, data) => {
              this.loading = false;
              if (!err && data) {
                this.weather = {
                  city: data.city || '',
                  weather: data.weather || '',
                  temperature: data.temperature || '',
                  winddirection: data.winddirection || '',
                  windpower: data.windpower || ''
                };
                // 发送天气数据给父组件
                this.$emit('weather-loaded', this.weather);
                // 获取天气预报（使用城市名称）
                this.getForecastByCity(data.city);
              }
            });
          });
        }
      } catch (e) {
        console.error('获取天气失败', e);
        this.loading = false;
      }
    },
    getForecastByCity(city) {
      if (!city || typeof AMap === 'undefined') return;
      
      AMap.plugin('AMap.Weather', () => {
        const weather = new AMap.Weather();
        weather.getForecast(city, (err, data) => {
          if (!err && data && data.forecasts) {
            this.forecast = data.forecasts;
            // 发送预报数据给父组件
            this.$emit('forecast-loaded', this.forecast);
          }
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.weather-card-wrapper {
  display: inline-block;
}

.weather-card {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  &.sunny {
    background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);
    .weather-icon i { color: #ff9800; }
  }

  &.cloudy {
    background: linear-gradient(135deg, #eceff1 0%, #cfd8dc 100%);
    .weather-icon i { color: #607d8b; }
  }

  &.rainy {
    background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
    .weather-icon i { color: #1976d2; }
  }

  &.snowy {
    background: linear-gradient(135deg, #e8eaf6 0%, #c5cae9 100%);
    .weather-icon i { color: #5c6bc0; }
  }

  &.weather-loading {
    background: #f5f7fa;
    color: #909399;
    font-size: 12px;
    
    i {
      margin-right: 4px;
    }
  }

  .weather-icon {
    i {
      font-size: 28px;
    }
  }

  .weather-content {
    display: flex;
    align-items: center;
    gap: 8px;

    .weather-city {
      font-size: 13px;
      color: #606266;
      padding-right: 8px;
      border-right: 1px solid rgba(0, 0, 0, 0.1);
    }

    .weather-text {
      font-size: 13px;
      color: #606266;
    }

    .weather-temp {
      font-size: 18px;
      font-weight: 600;
      color: #303133;
    }
  }

  .weather-arrow {
    margin-left: 4px;
    
    i {
      font-size: 12px;
      color: #909399;
      transition: transform 0.2s;
    }
  }

  &:hover .weather-arrow i {
    transform: translateY(2px);
  }
}
</style>

<style lang="less">
@color-primary:#2B77FF;

.weather-forecast-popover {
  padding: 0 !important;
  border-radius: 12px !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12) !important;

  // 底部弹出时的箭头
  &[x-placement^="bottom"] .popper__arrow {
    border-bottom-color: @color-primary !important;
    &::after {
      border-bottom-color: @color-primary !important;
    }
  }

    .forecast-empty {
      padding: 40px 20px;
      text-align: center;
      color: #909399;
      font-size: 13px;

      i {
        font-size: 24px;
        margin-bottom: 8px;
        display: block;
      }
    }

    .forecast-content {
      .forecast-header {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 14px 16px;
        background: linear-gradient(135deg, #2B77FF 0%, #1A5FD9 100%);
        border-radius: 12px 12px 0 0;
        color: #fff;
        font-size: 14px;
        font-weight: 500;

        i {
          font-size: 18px;
        }
      }

      .forecast-list {
        padding: 8px 0;

        .forecast-item {
          display: flex;
          align-items: center;
          padding: 10px 16px;
          transition: background 0.2s;

          &:hover {
            background: #f5f7fa;
          }

          &:first-child {
            background: rgba(43, 119, 255, 0.08);

            .forecast-date .day {
              color: #2B77FF;
              font-weight: 600;
            }
          }

          .forecast-date {
            width: 130px;
            display: flex;
            align-items: center;
            gap: 8px;
            flex-shrink: 0;

            .day {
              font-size: 13px;
              color: #303133;
              white-space: nowrap;
            }

            .week {
              font-size: 12px;
              color: #909399;
              white-space: nowrap;
            }
          }

          .forecast-weather {
            width: 90px;
            display: flex;
            align-items: center;
            gap: 6px;

            i {
              font-size: 18px;
              color: #2B77FF;
            }

            span {
              font-size: 13px;
              color: #606266;
            }
          }

          .forecast-temp {
            width: 100px;
            display: flex;
            align-items: center;
            gap: 4px;

            .temp-low {
              font-size: 13px;
              color: #909399;
            }

            .temp-range {
              flex: 1;
              height: 4px;
              background: linear-gradient(90deg, #91d5ff 0%, #ff7875 100%);
              border-radius: 2px;
              margin: 0 4px;
            }

            .temp-high {
              font-size: 13px;
              color: #f56c6c;
              font-weight: 500;
            }
          }

          .forecast-wind {
            flex: 1;
            text-align: right;
            font-size: 12px;
            color: #909399;
          }
        }
      }
    }
  }

</style>
